import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { useSpaceQueries } from "../lib/query";

export function BotAccessPanel({ botId }: { botId: string }) {
  const queries = useSpaceQueries();
  const members = useQuery(queries.bots.configurationMembers.queryOptions({ input: { botId } }));
  return (
    <section className="space-y-4">
      <div className="rounded-xl bg-muted/50 p-4">
        <h3 className="text-sm font-medium">
          <Trans>Settings access</Trans>
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          <Trans>Creator only</Trans>
        </p>
      </div>
      <h3 className="text-sm font-medium">
        <Trans>Users</Trans>
      </h3>
      {members.isError ? (
        <p role="alert" className="text-sm text-destructive">
          <Trans>Could not load access.</Trans>
        </p>
      ) : (
        <ul className="divide-y divide-border">
          {(members.data ?? []).map((member) => (
            <li key={member.userId} className="py-3 text-sm">
              {member.name}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
